import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { StrategyService } from '../../services/strategy.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-foundations',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './pillars.component.html',
  styleUrl: './pillars.component.scss',
  animations: [
    trigger('goalheader', [
      state('in', style({
        'transform': 'translateX(0)',
        'font-weight': '800',
        'font-size': '1.5rem',
        'margin-bottom': '0.5rem',
        'opacity': '1'
      })),
      transition('* <=> *', [style({ 'opacity': '0', 'transform': 'translateX(-6rem)', }), animate('0.7s')])
    ]
    ),

    trigger('goalBody', [
      state('in', style({
        'transform': 'translateX(0)',
        'font-weight': '700',
        'margin-bottom': '0.5rem',
        'opacity': '1'
      })),
      transition('* <=> *', [style({ 'opacity': '0', 'transform': 'translateX(-6rem)', }), animate('0.7s')])
    ]
    ),

  ]
})
export class PillarsComponent implements OnInit {
  isHovered = true;
  pillars!: any[];
  selectedpillar = {} as any;
  // stateCard = 'cardOneDefault'
  constructor(private strategyService: StrategyService) {
  }
  ngOnInit(): void {
    this.strategyService.defaultStrategPillars$.subscribe((response) => {
      const pillarsMapped = response.map((pillar: any) => {
        return {
          char: pillar.char,
          pillar_name: pillar.name,
          pillar_description: pillar.description,
          goals: pillar.goals
        }
      })
      this.pillars = pillarsMapped.splice(0, 4);
      this.selectedpillar = this.pillars[0];
    })
  }
  onMouseEnter(index: number) {
    this.isHovered = false;
    this.selectedpillar = this.pillars[index];
  }
  onMouseLeave(event: Event) {
    this.isHovered = true;
    // this.stateCard = 'cardOneDefault'
    this.selectedpillar = this.pillars[0]
  }
}
